/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import {
    createHandlerChainRunner,
    HandlerWithResult,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { updateQuoteLine as updateQuoteLineApi } from "@insite/client-framework/Services/QuoteService";
import { QuoteLineModel } from "@insite/client-framework/Types/ApiModels";

interface UpdateQuoteLineResult {
    quoteLine?: QuoteLineModel;
    errorMessage?: string;
}

type HandlerType = HandlerWithResult<
    {
        quoteId: string;
        quoteLineId: string;
        quoteLine: QuoteLineModel;
        keepQuotesData?: boolean;
    } & HasOnSuccess<any>,
    UpdateQuoteLineResult
>;

export const RequestUpdateQuoteLine: HandlerType = async props => {
    props.dispatch({ type: "xCommon/update", data: { key: "isUpdatingQuoteLine", value: true } });
    (props as any).apiResult = await updateQuoteLineApi({
        quoteId: props.parameter.quoteId,
        quoteLineId: props.parameter.quoteLineId,
        quoteLine: props.parameter.quoteLine,
    });
};

export const ResetQuotesData: HandlerType = props => {
    if (!props.parameter.keepQuotesData) {
        props.dispatch({
            type: "Data/Quotes/Reset",
        });
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.dispatch({ type: "xCommon/update", data: { key: "isUpdatingQuoteLine", value: false } });
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props);
};

export const chain = [RequestUpdateQuoteLine, ResetQuotesData, ExecuteOnSuccessCallback];

const updateQuoteLine = createHandlerChainRunner(chain, "UpdateQuoteLine");
export default updateQuoteLine;
